import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './CardInfo.css';
import card_no_image from '../../assets/card_no_image.jpg';
import card_back from '../../assets/card_back.jpg';
import img_rotate from './rotate_w_100.png';

import { useMtg } from '../../hook/useMtg';
import { useSet } from '../../hook/useSet';
import { buildClass } from '../../libs/classes';
import { parsePrice } from '../../libs/helper';

/**
 * Represent card information
 * @component
 */
const CardInfo = ({ card, children }) => {
	const [rotate, setRotate] = useState(false);
	const [zoom, setZoom] = useState(false);

	const { getCardRarity } = useMtg();
	const { sets } = useSet();

	useEffect(() => {
		console.log('Initialization: CardInfo');
	}, []);

	useEffect(() => {
		// Reset rotate and zoom states
		setRotate(false);
		setZoom(false);
	}, [card]);

	const getSetCode = () => {
		const set_id = card['set_id'];
		if (set_id in sets) {
			return sets[set_id].code.toUpperCase();
		}
		return '?';
	};
	const getSetName = () => {
		const set_id = card['set_id'];
		if (set_id in sets) {
			return sets[set_id].name;
		}
		return 'Unknown Set';
	};

	return (
		<div className="card-info">
			{card ? (
				<div className="card-info-wrapper">
					<div className={'image' + (zoom ? ' zoom' : '')}>
						<div
							className={
								'flipper' + (card.image_normal_uri_2 ? ' doublesided' : '') + (rotate ? ' flip' : '')
							}
						>
							<div className="flipper-outer">
								<div className="flipper-inner">
									<div className="front" onClick={handleZoom}>
										{(card.image_normal_uri && (
											<img
												alt={(card ? card.name + ' ' : '') + '(Front)'}
												draggable="false"
												src={card.image_normal_uri}
											/>
										)) || (
											<img
												alt={(card ? card.name + ' ' : '') + '(Front, No Image)'}
												draggable="false"
												src={card_no_image}
											/>
										)}
									</div>
									<div className="back" onClick={handleZoom}>
										{(card.image_normal_uri_2 && (
											<img
												alt={(card ? card.name + ' ' : '') + '(Back)'}
												draggable="false"
												src={card.image_normal_uri_2}
											/>
										)) || (
											<img
												alt={(card ? card.name + ' ' : '') + '(Back, No Image)'}
												draggable="false"
												src={card_back}
											/>
										)}
									</div>
								</div>
								<div className="flip-button" title="flip" onClick={handleRotate}>
									<img alt="flip" src={img_rotate} />
								</div>
							</div>
						</div>
						<div className="sub-image">
							<div className="number" title={getSetName()}>
								{getSetCode()}&nbsp;{card['c_number']}
							</div>
							<div className={buildClass('rarity').add(card['rarity'], `rarity-${card['rarity']}`)}>
								{getCardRarity(card)}
							</div>
						</div>
					</div>
					<div className="info">
						<div className="name">{card ? card.name : ''}</div>
						<div className="properties">
							<div className="h-block">
								<div className={'finish ' + (card['nonfoil'] ? 'yes' : 'no')}>
									<span className="yes" title="Available in non-foil version">
										☑️
									</span>
									<span className="no" title="Doesn't available in non-foil version">
										⬜
									</span>{' '}
									Non Foil
								</div>
								<div className={'finish ' + (card['foil'] ? 'yes' : 'no')}>
									<span className="yes" title="Available in foil version">
										☑️
									</span>
									<span className="no" title="Doesn't available in foil version">
										⬜
									</span>{' '}
									Foil
								</div>
								{card['etched'] ? (
									<div className={'finish ' + (card['etched'] ? 'yes' : 'no')}>
										<span className="yes" title="Available in etched version">
											☑️
										</span>{' '}
										Etched
									</div>
								) : null}
							</div>
							<div className="h-block">
								<div className="price-row">{parsePrice(card.price_usd, card['nonfoil'])}</div>
								<div className="price-row">{parsePrice(card.price_usd_foil, card['foil'])}</div>
								{card['etched'] ? (
									<div className="price-row">{parsePrice(card.price_usd_etched, card['etched'])}</div>
								) : null}
							</div>
							<div className="spacer" />
						</div>
						<div className="spacer" />
						<div className="extended">{children}</div>
					</div>
				</div>
			) : null}
		</div>
	);

	function handleRotate() {
		setRotate(!rotate);
	}

	function handleZoom() {
		setZoom(!zoom);
	}
};

CardInfo.propTypes = {
	// Card object
	card: PropTypes.object.isRequired,
	// Extended information
	children: PropTypes.node,
};

export default CardInfo;
